"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UApageView = exports.sendUAEvent = exports.sendEvent = exports.queue = exports.pageView = exports.heap = void 0;
// TODO [balazs] - could be refactored to a boolean once ava is replaced with vitest
var isBrowser = function () { return typeof window !== 'undefined'; };
/**
 * Wraps the passed callback in a new callback which will be executed async.
 *
 * @param callback - The callback that will be executed after 800ms async with setTimeout.
 * @returns The new callback wrapper.
 */
var createCallbackWithTimeout = function (callback) {
    var called = false;
    var fn = function () {
        if (!called) {
            called = true;
            callback();
        }
    };
    setTimeout(fn, 800);
    return fn;
};
/**
 * Enqueues a Universal Analytics (UA) or Google Analytics 4 (GA4) event for later processing.
 * If window.dataLayer does not exist, it creates a new array.
 * If the payload contains an eventCallback, it creates a new callback with a timeout.
 *
 * @param {UAEvent | GA4Event} payload - The data to be queued.
 * @returns {void} - This function does not return anything.
 */
var queue = function (payload) {
    if (isBrowser()) {
        if (typeof window.dataLayer === 'undefined') {
            window.dataLayer = [];
        }
        if (payload.eventCallback) {
            payload.eventCallback = createCallbackWithTimeout(payload.eventCallback);
        }
        window.dataLayer.push(payload);
    }
};
exports.queue = queue;
/**
 * Adds a Universal Analytics sendVirtualPageview event to the dataLayer.
 * TODO [devinl] - Remove this after UA's sunset in 7/2023
 *
 * @param pageTitle - The title of the page. Uses document.title as a default.
 * @param pagePath - The path of the page, starting with a forward slash. Uses window.location.pathname as a default.
 * @returns void
 */
var UApageView = function (pageTitle, pagePath) {
    queue({
        event: 'sendVirtualPageview',
        virtualPagePath: pagePath ? pagePath : isBrowser() ? window.location.pathname : undefined,
        virtualPageTitle: pageTitle ? pageTitle : isBrowser() ? document.title : undefined
    });
};
exports.UApageView = UApageView;
/**
 * Adds a GA4 send_virtual_pageview event to the dataLayer.
 *
 * @param pageTitle - The title of the page. Uses document.title as a default.
 * @param pagePath - The path of the page. Uses window.location.pathname as a default.
 * @returns void
 */
var pageView = function (pageTitle, pagePath) {
    if (pageTitle === void 0) { pageTitle = document.title; }
    if (pagePath === void 0) { pagePath = window.location.pathname; }
    queue({
        event: 'send_virtual_pageview',
        virtual_page_path: pagePath,
        virtual_page_title: pageTitle
    });
};
exports.pageView = pageView;
var convertEventValue = function (payload) {
    if (payload === void 0) { payload = {}; }
    var value = null;
    if (payload.value) {
        if (typeof payload.value === 'string') {
            value = parseFloat(payload.value);
            value = isNaN(value) ? null : value;
        }
        else if (typeof payload.value === 'number') {
            value = payload.value;
        }
    }
    return value;
};
/**
 * Adds a Universal Analytics event to the dataLayer.
 * TODO [devinl] - Remove this after UA's sunset in 7/2023
 *
 * @param payload - A payload of key/value pairs to be added to the data layer. May contain an optional callback.
 * @returns void
 */
var sendUAEvent = function (payload) {
    if (payload === void 0) { payload = {}; }
    if (!payload.category || !payload.action) {
        throw new Error('Event must have a category and action');
    }
    var eventConfig = __assign(__assign({ event: 'trackEvent' }, payload), { value: convertEventValue(payload) });
    queue(eventConfig);
};
exports.sendUAEvent = sendUAEvent;
/**
 * Adds a GA4 event to the dataLayer.
 * GTM will collect the event and forward it to GA.
 *
 * @param payload - A payload of key/value pairs to be added to the data layer. May contain an optional callback.
 * @returns void
 */
var sendEvent = function (payload) {
    if (payload === void 0) { payload = {}; }
    var eventConfig = __assign(__assign({ event: 'track_event' }, payload), { value: convertEventValue(payload) });
    if (eventConfig.value) {
        eventConfig.currency = 'USD';
    }
    queue(eventConfig);
};
exports.sendEvent = sendEvent;
/**
 * Track custom events with Heap.
 */
var heap = {
    track: function (event, payload) {
        if (isBrowser() && window.heap) {
            window.heap.track(event, payload);
        }
    }
};
exports.heap = heap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@doxo/willow-analytics/dist/index.js
// module id = 3zSk
// module chunks = 3 4 5 6 7 8 9